import React from "react";
import { Route, Switch } from "react-router-dom"

import TaskStepper from "./TaskStepper";

const DashboardRoutes = () => {
    return (
        <React.Fragment>
            <Switch>

                <Route exact path="/dashboard/document/:taskId/view" component={TaskStepper} />
                <Route exact path="/dashboard/document/:taskId/attest" component={TaskStepper} />
                <Route exact path="/dashboard/document/:taskId/finalize" component={TaskStepper} />

                <Route exact path="/dashboard/video/:taskId/view" component={TaskStepper} />
                <Route exact path="/dashboard/video/:taskId/attest" component={TaskStepper} />
                <Route exact path="/dashboard/video/:taskId/finalize" component={TaskStepper} />

                <Route exact path="/dashboard/question/:taskId/view" component={TaskStepper} />
                <Route exact path="/dashboard/question/:taskId/finalize" component={TaskStepper} />

                <Route exact path="/dashboard/task/:taskId/view" component={TaskStepper} />
                <Route exact path="/dashboard/task/:taskId/finalize" component={TaskStepper} />

            </Switch>
        </React.Fragment>
    );
};

export default DashboardRoutes;
